import React, { FC } from "react";
import type { PaymentChannelsDetermineCorridorsProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PaymentChannelsDetermineCorridors: FC<
  PaymentChannelsDetermineCorridorsProps
> = ({ content, cover }) => {
  return (
    <section className="paymentChannelsDetermineCorridors">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={567} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentChannelsDetermineCorridors--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
